export const testimonials = [
  {
    name: "Dr. Michael Evans",
    role: "Plastic Surgeon · Austin, Texas",
    photo: "https://cdn.magicpatterns.com/patterns/generated-images/06cc6db3-5933-4ac5-a7c2-9e65304181a2.jpg",
    quote:
      "I had years of lecture notes spread across three apps. The six-stage framework finally gave me one place to start every case review — and one place to record what I still need to read.",
  },
  {
    name: "Dr. Grace Lin",
    role: "Facial Plastic Surgery Fellow · Vancouver",
    photo: "https://cdn.magicpatterns.com/patterns/generated-images/a3e836b1-b5d6-4ee0-aefc-0cd4d0c2805d.jpg",
    quote:
      "The 15-Minute Review Sheet is what I use before journal club now. It keeps me focused on the questions that matter instead of re-reading everything from scratch.",
  },
  {
    name: "Dr. Marcus Bennett",
    role: "Plastic Surgery Resident · Atlanta, Georgia",
    photo: "https://cdn.magicpatterns.com/patterns/generated-images/b6e148e1-10f2-4e31-bfcc-cddd93afd2d8.jpg",
    quote:
      "The Case Atlas turned passive studying into active practice. Working through the exercises with the same structure every time made my notes far more consistent.",
  },
  {
    name: "Dr. Helen Whitaker",
    role: "Aesthetic Surgeon · London, UK",
    photo: "https://cdn.magicpatterns.com/patterns/generated-images/9648f425-63e5-46f6-9908-e1a1fad02e91.jpg",
    quote:
      "What I value most is the Learning Archive. After a few weeks I had a real record of the concepts I reviewed and the gaps I wanted to close. Well worth it for the price.",
  },
];
